import { ResErr } from '@/newApi/services/ResgateManager';

export function assertNotResErr<T>(res: T | ResErr): T {
    if (res instanceof ResErr) {
        throw new Error(res.message);
    }
    return res;
}
